<template>

  <p>{{ insert[lang].loginPlease }}</p>

  <form @submit.prevent="login" class="loginForm">
    <div class="mb-3">
      <label for="exampleInputEmail1" class="form-label">{{ insert[lang].login }}</label>
      <input type="email" v-model="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" required>
    </div>
    <div class="mb-3">
      <label for="exampleInputPassword1" class="form-label">{{ insert[lang].password }}</label>
      <input type="password" v-model="password" class="form-control" id="exampleInputPassword1" required>
    </div>
    <div class="d-flex align-items-center">
      <button type="submit" class="btn btn-primary mr-15">{{ insert[lang].enterButton }}</button>
      <div v-if="isAuthLoading" class="loader1"></div>
    </div>
  </form>
</template>

<script>
import useAuth from '@/hooks/useAuth'
import insert from '@/data/languages/LoginFormData.js'
import useLang from '@/hooks/useLang'
import { define } from '@/data/globals.js'

export default {
  setup() {
    const { email, password, login, isAuthLoading } = useAuth()
    const { lang } = useLang()

    return { email, password, login, isAuthLoading, lang, insert, define }
  }
}
</script>

<style>
.loginForm {
  max-width: 400px;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 1px 1px 5px 5px #00000015;
}
</style>
